<template>
  <div class="page_view">
    <div class="page_title backdrop">Original Composition</div>
    <div v-for="comp in compositionModels"
         :key="comp.id()"
         class="panel backdrop">
      <div class="panel_header">
        <div class="panel_title">
          <div class="composition_name">{{ comp.name() }}</div>
          <div class="duration">{{ comp.durationString() }}</div>
        </div>
      </div>
      <div class="panel_body">
        <div class="description">
          {{ comp.description() }}
          <table class="movements" v-if="comp.movements().length">
            <tbody>
              <tr class="movement"
                  v-for="(mvmt, index) in comp.movements()"
                  :key="index">
                <td class="number">{{ mvmt.number() }}.</td>
                <td class="name">{{ mvmt.name() }}</td>
                <td class="duration">{{ mvmt.durationString() }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="file_group">
          <div v-for="(group, grpIdx) in comp.fileGroups()" :key="grpIdx">
            <table class="file_table">
              <tbody>
                <tr v-for="(file, fileIdx) in group" :key="fileIdx">
                  <td class="file_meta">
                    <a :href="file.url()">
                      <span class="file_name" v-if="file.name()">{{ file.name() }}</span>
                      <span class="file_type">{{ file.fileType() }}</span>
                    </a>
                  </td>
                  <td class="file_size">{{ file.size() }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="panel_footer">
        &copy; {{ comp.year() }}
      </div>
    </div>
  </div>
</template>

<script>

import Composition from '@/model/composition';

export default {
    name : "Music",
    data() {
        return {
            compositions : [
                {
                    name        : "Andante-Allegro",
                    duration    : 246,
                    year        : 2011,
                    description : "This is a work in progress. It's the " +
                                  "introduction and exposition (without " +
                                  "repeats) of the first movement of a " +
                                  "symphony in G.",
                    files       : [
                        [
                            {
                                url  : "/audio/andante-allegro.aiff",
                                size : 43461686
                            },
                            {
                                url  : "/audio/andante-allegro.m4a",
                                size : 8196775
                            }
                        ]
                    ]
                },
                {
                    name        : "Steam",
                    duration    : 251,
                    year        : 2005,
                    description : "An 80s-style instrumental " +
                                  "dance/electronic piece completed in 2005.",
                    files       : [
                        [
                            {
                                url  : "/audio/steam.mp3",
                                size : 4025023
                            },
                            {
                                url  : "/audio/steam.m4a",
                                size : 8384073
                            }
                        ]
                    ]
                },
                {
                    name        : "Runaway",
                    duration    : 314,
                    year        : 2004,
                    description : "Completed in January 2004, Runaway " +
                                  "represents a departure from classical " +
                                  "forms. Inspired by Swing Out Sister, " +
                                  "its instrumentation and harmony lean " +
                                  "more towards jazz and pop, with no formal " +
                                  "structure.",
                    files       : [
                        [
                            {
                                url  : "/audio/runaway.mp3",
                                size : 5023716
                            },
                            {
                                url  : "/audio/runaway.m4a",
                                size : 10410449
                            }
                        ]
                    ]
                },
                {
                    name        : "Allegro in F Major",
                    duration    : 659,
                    year        : 2002,
                    description : "Begun in January 1999 and completed in " +
                                  "April 2002, this Classical-style Allegro " +
                                  "is an orchestral piece cast in sonata-" +
                                  "allego form.",
                    files       : [
                        [
                            {
                                url  : "/audio/allegro.mp3",
                                size : 7012063
                            },
                            {
                                url  : "/audio/allegro.m4a",
                                size : 16486588
                            }
                        ]
                    ]
                },
                {
                    name        : "String Quartet in G Major",
                    duration    : 1591,
                    year        : 2001,
                    description : "A Classical-style string quartet in 4 " +
                                  "movements.",
                    movements   : [
                        {
                            number   : "I",
                            name     : "Allegro",
                            duration : 605
                        },
                        {
                            number   : "II",
                            name     : "Andante",
                            duration : 403
                        },
                        {
                            number   : "III",
                            name     : "Minuet",
                            duration : 178
                        },
                        {
                            number   : "IV",
                            name     : "Allegro",
                            duration : 405
                        }
                    ],
                    files       : [
                        [
                            {
                                name : "I. Allegro",
                                url  : "/audio/sq_g_maj_1_allegro.m4a",
                                size : 20419233
                            },
                            {
                                name : "II. Andante",
                                url  : "/audio/sq_g_maj_2_andante.m4a",
                                size : 13689197
                            },
                            {
                                name : "III. Minuet",
                                url  : "/audio/sq_g_maj_3_minuet.m4a",
                                size : 6052749
                            },
                            {
                                name : "IV. Allegro",
                                url  : "/audio/sq_g_maj_4_allegro.m4a",
                                size : 13796728
                            }
                        ],
                        [
                            {
                                name : "I. Allegro",
                                url  : "/audio/sq_g_maj_1_allegro.mp3",
                                size : 12108942
                            },
                            {
                                name : "II. Andante",
                                url  : "/audio/sq_g_maj_2_andante.mp3",
                                size : 8053172
                            },
                            {
                                name : "III. Minuet",
                                url  : "/audio/sq_g_maj_3_minuet.mp3",
                                size : 3567425
                            },
                            {
                                name : "IV. Allegro",
                                url  : "/audio/sq_g_maj_4_allegro.mp3",
                                size : 8096535
                            }
                        ]
                    ]
                },
                {
                    name        : "Fugue in G Major",
                    duration    : 150,
                    year        : 2000,
                    description : "Written in 2000 as an exercise in " +
                                  "counterpoint.",
                    files       : [
                        [
                            {
                                url  : "/audio/fugue_g_maj.mp3",
                                size : 1500476
                            },
                            {
                                url  : "/audio/fugue_g_maj.m4a",
                                size : 2606638
                            }
                        ]
                    ]
                },
                {
                    name        : "Fugue in C Major",
                    duration    : 92,
                    year        : 2000,
                    description : "Written in 2000 as an exercise in " +
                                  "counterpoint.",
                    files       : [
                        [
                            {
                                url  : "/audio/fugue_c_maj.mp3",
                                size : 918729
                            },
                            {
                                url  : "/audio/fucue_g_maj.m4a",
                                size : 1619129
                            }
                        ]
                    ]
                },
                {
                    name        : "Bourrée",
                    duration    : 37,
                    year        : 2000,
                    description : "A bourrée is a 17-century French dance " +
                                  "form. Written for piano as an exercise " +
                                  "in 2000.",
                    files       : [
                        [
                            {
                                url  : "/audio/bourree.mp3",
                                size : 373285
                            },
                            {
                                url  : "/audio/bourree.m4a",
                                size : 633383
                            }
                        ]
                    ]
                }
            ]
        };
    },
    computed : {
        compositionModels() {
            return this.compositions.map((data) => {
                return new Composition(data);
            });
        }
    }
};

</script>

<style scoped>

.composition_name, .duration {
    line-height:32px;
}

.duration {
    font-family:monaco;
    font-size:65%;
}

.duration:before {
    content:"(";
}

.duration:after {
    content:")";
}

.description {
    font-size:18px;
    flex-grow:2;
}

.file_table {
    border-spacing:0px;
    border-collapse:collapse;
    margin-left:20px;
    margin-bottom:25px;
}

.file_table td {
    font-size:18px;
    padding:0px;
    white-space:nowrap;
}

.file_table td.file_meta {
    font-weight:bold;
    text-align:right;
    padding-right:10px;
}

.file_name {
    padding-right:0.5em;
}

.file_type {
    text-transform:uppercase;
}

.file_table td.file_size {
    text-align:left;
    padding-left:10px;
}

.file_table td.file_size:before {
    content:"(";
}

.file_table td.file_size:after {
    content:")";
}

.movements {
    margin:10px 25px 0px;
}

.movements td {
    text-align:left;
    padding-right:15px;
}

.movements td.number {
    text-align:right;
    padding-right:5px;
}


@media only screen and (max-width:500px) {
    .description {
        font-size:16px;
    }

    .file_table {
        margin-left:0px;
        margin-top:20px;
    }

    .file_table td {
        font-size:16px;
        padding:0px;
        white-space:nowrap;
    }
}

</style>
